import { roundToCurrencyPrecision } from '@insio/decimal';
import type { CurrencyCode } from '@insio/shared-types';
import type { InvoiceLine, InvoiceLineAmounts } from '../../../../graphql/generated/graphql';
import { computeMismatchFields } from './diff-computed-from-typed';
import { updateLineField } from './update-line-field';

/** Fill blank derivable fields of `line` from `fresh` and overwrite disagreeing ones,
 * currency-rounded. Returns `line` itself when nothing changes. */
export function normalizeLine(
  line: Partial<InvoiceLine>,
  fresh: InvoiceLineAmounts,
  isVatDocument: boolean,
  currencyCode: CurrencyCode | undefined
): Partial<InvoiceLine> {
  let updated = line;
  for (const field of computeMismatchFields(fresh, line, isVatDocument)) {
    const value = fresh[field];
    if (value != null) {
      updated = updateLineField(updated, field, roundToCurrencyPrecision(value, currencyCode));
    }
  }
  return updated;
}
